export enum DashboardTranslationKey {
    IFRAME_TITLE = "dashboard.iFrame.title",
    NAME = "dashboard.name",
    ADMINISTRATION = "dashboard.pageAdministration",
    DIAGRAM = "dashboard.textField.diagram",
    URL = "dashboard.textField.url",
    WITHOUT_DASHBOARD = "dashboard.textField.withoutDashboard",
    SEARCH_DIAGRAM = "dashboardAdministration.tooltip.searchDiagram",
    SUCCESSFUL_SAVE = "dashboardAdministration.succeededAlert.alertText",
    NOT_SUCCESSFUL_SAVE = "dashboardAdministration.notSucceededAlert.alertText"
}